import "../scss/base.scss";

export { createHeader } from "./entry-core";
